import DlightUgandaDataTable from "./DlightUgandaDataTable";
import * as commonStyles from "styles/Common.module.scss";
import CollapsibleFilterChildren from "./CollapsibleFilterChildren/CollapsibleFilterChildren";
import CollapsibleTopSection from "components/common/CollapsibleTopSection/CollapsibleTopSection";
import CustomLoader from "components/common/CustomLoader/CustomLoader";
import NoDataFound from "components/common/NoDataFound/NoDataFound";
import { toast } from "react-toastify";
import { useInfiniteQuery } from "react-query";
import { useState } from "react";
import { getDlightUgandaDataList } from "common/API/dlightUgandaAPIs";
import DlightUgandaDataSearch from "./DlightUgandaDataSearch";
import { getErrorMessage } from "common/utils/errorUtils";

const DlightUgandaDataList = () => {
  const [searchOptions, setSearchOptions] = useState({});
  const [toggleFilters, setToggleFilters] = useState(false);

  const { isLoading, isError, error, data, fetchNextPage, hasNextPage } =
    useInfiniteQuery(
      ["dlight-uganda-data", searchOptions],
      ({ pageParam = 1 }) =>
        getDlightUgandaDataList({
          pageParam,
          pageSize: 20,
          searchOptions,
        }),
      {
        refetchInterval: Infinity,
      }
    );

  if (isError)
    toast.error(getErrorMessage(error, "Cannot fetch delight uganda data"));

  const dlightUgandaData = data?.pages.flatMap((page) => page.data.results);
  const lastPage = data?.pageParams.at(-1) || 1;
  const noDataFound = !dlightUgandaData || dlightUgandaData?.length === 0;
  return (
    <>
      <CollapsibleTopSection
        {...{
          searchOptions,
          extraChildren: (
            <DlightUgandaDataSearch
              {...{ searchOptions, setSearchOptions, isLoading }}
            />
          ),
          collapsibleFilterChildren: (
            <CollapsibleFilterChildren
              {...{ searchOptions, setSearchOptions }}
            />
          ),
          emptySearchOptionsToConsider: ["product_model", "cpa_number"],
          toggleFilters,
          setToggleFilters,
        }}
      />
      <DlightUgandaDataTable
        {...{
          fetchNextPage,
          lastPage,
          hasNextPage,
          dlightUgandaData,
          isLoading,
          noDataFound,
          extraClass: noDataFound
            ? ""
            : toggleFilters
            ? "Table_Height3"
            : "Table_Height1",
        }}
      />
      {isLoading && (
        <CustomLoader
          {...{ containerClasses: commonStyles.Table_Body_Loader_Container }}
        />
      )}
      {noDataFound && !isLoading && (
        <NoDataFound
          {...{
            title: "No data found for requested search",
            wrapperClasses: commonStyles.Table_Body_Loader_Container,
          }}
        />
      )}
    </>
  );
};

export default DlightUgandaDataList;
